module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/donate/donate.component.scss
// module id = ./src/app/donate/donate.component.scss
// module chunks = main